// E — monumental construction, an original independent 7.8 second study.
import {createEWorld} from './e-world.js';
const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
const smooth=(a,b,t)=>{const p=clamp((t-a)/(b-a));return p*p*(3-2*p);};
const DESKTOP=[
  {at:0,p:[2.6,9.2,2.4],look:[.6,9.0,.4],fov:35},
  {at:.70,p:[6.5,7.0,11],look:[.8,7.5,.2],fov:39},
  {at:1.85,p:[14,6.5,27],look:[0,8,0],fov:42},
  {at:3.35,p:[7.5,2.6,16],look:[1,7.6,-6],fov:46},
  {at:5.05,p:[3.2,4.4,5.8],look:[0,8.2,-15],fov:49},
  {at:6.75,p:[12.5,11.2,15],look:[-.5,8.2,-17],fov:48}
];
const PORTRAIT=[
  {at:0,p:[1.7,9.1,3.1],look:[.5,9.0,.4],fov:45},
  {at:.70,p:[4,7.2,12],look:[.1,8.1,0],fov:55},
  {at:1.85,p:[6.5,7.6,40],look:[0,8.2,0],fov:60},
  {at:3.35,p:[2,4.6,32.5],look:[0,8,0],fov:66},
  {at:5.05,p:[1.3,6,9.3],look:[0,10,-17],fov:64},
  {at:6.75,p:[8.5,9,24],look:[-1.5,7.4,-17],fov:55}
];
// Time-aware Hermite tangents keep the macro pullback / push / crane one
// continuous camera move, with zero velocity at the first frame and final hold.
export function eCameraAt(seconds,portrait=false){
  const keys=portrait?PORTRAIT:DESKTOP,t=clamp(seconds,0,6.75);
  let i=0;while(i<keys.length-2&&t>keys[i+1].at)i++;
  const a=keys[i],b=keys[i+1],duration=b.at-a.at,u=clamp((t-a.at)/duration),u2=u*u,u3=u2*u;
  const tangent=(index,field,axis)=>{if(index===0||index===keys.length-1)return 0;return(keys[index+1][field][axis]-keys[index-1][field][axis])/(keys[index+1].at-keys[index-1].at);};
  const vector=field=>[0,1,2].map(axis=>(2*u3-3*u2+1)*a[field][axis]+(u3-2*u2+u)*duration*tangent(i,field,axis)+(-2*u3+3*u2)*b[field][axis]+(u3-u2)*duration*tangent(i+1,field,axis));
  return{position:vector('p'),target:vector('look'),fov:a.fov+(b.fov-a.fov)*(u2*(3-2*u))};
}
export function createE({THREE:T,scene,camera,renderer,portrait=false}) {
  const world=createEWorld({THREE:T,scene,portrait});
  let time=0,isPortrait=!!portrait;
  const duration=7.8,holdStart=6.75;
  function update(seconds) {
    time=clamp(Number(seconds)||0,0,duration);
    const t=Math.min(time,holdStart);
    world.update({time:t,assemble:smooth(.55,2.6,t),open:smooth(2.65,5.8,t),light:smooth(3.8,6.55,t)});
    const pose=eCameraAt(t,isPortrait);camera.position.set(...pose.position);camera.lookAt(...pose.target);
    if(camera.fov!==pose.fov){camera.fov=pose.fov;camera.updateProjectionMatrix();}
    renderer.toneMappingExposure=.70+.36*smooth(3.5,6.6,t);
    scene.userData.intro={variant:'E',time,phase:t<.95?'material':t<3.2?'construction':t<5.4?'space':time<holdStart?'sun':'hold',portrait:isPortrait};
  }
  function resize(value){isPortrait=!!value;world.resize?.(isPortrait);update(time);camera.updateProjectionMatrix();}
  update(0);
  return {duration,endcardTone:'dark',dynamicShadows:true,update,resize,dispose(){world.dispose();},inspect(){return{...scene.userData.intro,camera:{position:camera.position.toArray(),fov:camera.fov},world:world.inspect()};}};
}
